import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.hasConsent()) {
      this.element.remove()
    }
  }

  accept() {
    document.cookie = "cookie_consent=accepted; path=/; max-age=31536000; SameSite=Lax"
    this.element.remove()
  }

  hasConsent() {
    return document.cookie.split(";").some(c => c.trim().startsWith("cookie_consent="))
  }
}
